module.exports = __webpack_public_path__ + "img/cegeco.6098e2a4.png";